<template>
    <div class="layout">
        <m-assembly-table :total="total"
                        :loading="loading"
                        :formData="formData"
                        :columns="columns"
                        :settings="settings"
                        :data="tableData"
                        :tableButtons="tableButtons"
                        @onSubmit="onSubmit"
                        @onSelectionChange="onSelectionChange"
                        ref="table">
        </m-assembly-table>
        <div style="padding:20px;text-align:right;">
            <Button type="primary" :disabled="submitSelection.length === 0" :loading="loading" @click="reportOrderMatch">{{ $t('确定') }}</Button>
        </div>

        <!--首检检验报告-->
        <Modal :title="$t('首检检验报告')"
               width="1100"
               v-model="Modal1"
               :closable="false"
               :mask-closable="false"
               >
               <Table border v-if="modalTableShow" :columns="ModalColumns1" :data="ModalData1" :loading="loading"></Table>
               <div slot="footer">
                   <Button type="ghost" @click="cancelReportSelect">{{ $t('processInspectionSearch.t100') }}</Button>
                   <Button type="primary" @click="confirmReportSelect">{{ $t('processInspectionSearch.t101') }}</Button>
               </div>
        </Modal>

        <!--送货单-->
        <Modal :title="$t('送货单')"
               width="700"
               v-model="Modal2"
               :closable="false"
               :mask-closable="false"
               >
               <Table border v-if="modalTableShow" :columns="ModalColumns2" :data="ModalData2" :loading="loading"></Table>
               <div style="margin-top:10px;font-size:14px;">{{$t('合计数量')}}:{{selectDeliveryCount}}</div>
               <div slot="footer">
                   <Button type="ghost" @click="cancelDeliverySelect">{{ $t('取消') }}</Button>
                   <Button type="primary" @click="confirmDeliverSelect">{{ $t('确定') }}</Button>
               </div>
        </Modal>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import axios from 'axios';
export default {
    name: 'processInspectionMatch',
    components: {
        mAssemblyTable
    },
    props: {
        isOutOrder: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            buList: [],
            releaseLockObj: {
                itemCode: '',
                buName: ''
            },
            allFilterTableData: [],
            tempObj: {
                reportNumber: '',
                batchNumber: ''
            },
            beforeItemCode: '',
            isLocal: false,
            chooseType: '',
            total: 0,
            loading: false,
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgName',
                        disabled: true,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('processInspectionSearch.t13'), // 库存组织
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        disabled: true,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('物料编码')
                    },
                    {
                        value: '',
                        field: 'itemName',
                        disabled: true,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('物料描述')
                    },
                    {
                        value: '2',
                        field: 'matchType',
                        layout: {
                            span: 8,
                            row: 1
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.isOutOrder ? '按外租仓送货单' : '按送货单',
                                    value: '1'
                                },
                                {
                                    label: '按首检检验报告',
                                    value: '2'
                                }
                            ],
                            clearable: false
                        },
                        validators: {
                        required: {
                            required: true,
                            message: this.$t('匹配方式不能为空')
                        }
                        },
                        type: 'select',
                        title: this.$t('匹配方式'),
                        methods: {
                            change: () => {
                                this.copyTableData = this.copyData(this.tableData);
                                let val = this.getFormDataItemVal(this.formData.items, 'matchType');
                                if (val === '1') {
                                    this.columns.columns = this.tableColumns1.filter((item) => !item.hide);
                                } else {
                                    this.columns.columns = this.tableColumns2.filter((item) => !item.hide);
                                }
                                this.tableData = [];
                                this.onSubmit();
                            }
                        }
                    }
                ],
                buttons: {
                    submitText: this.$t('匹配')
                }
            },
            columns: {
                columns: []
            },
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
                needClear: false,
                onlyLeftPart: true
            },
            tableButtons: {
                customButtons: []
            },
            tableData: [],
            tableData1: [],
            tableData2: [],
            tableColumns1: [
                {
                    type: 'selection',
                    align: 'center',
                    width: 35
                },
                {
                    title: this.$t('送货单条码号'),
                    key: 'barcodeNumber',
                    width: 100
                },
                {
                    title: this.$t('送货单号'),
                    key: 'deliveryNumber',
                    width: this.isOutOrder ? 120 : 100
                },
                {
                    title: this.$t('需求日期'),
                    key: 'needByDate',
                    width: 120,
                    hide: this.isOutOrder
                },
                {
                    title: this.$t('送货数量'),
                    key: 'deliveryQuantity',
                    align: 'right',
                    width: 80
                },
                {
                    title: this.$t('批次检验单号'),
                    minWidth: 450,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', {
                            attrs: {
                                title: params.row.reportNumbers
                            }
                        }, [
                            h('Input', {
                                props: {
                                    icon: 'search',
                                    value: params.row.reportNumbers,
                                    size: 'small',
                                    readonly: true
                                },
                                style: {
                                    width: '380px'
                                },
                                on: {
                                    'on-click': () => {
                                        this.Modal1 = true;
                                        this.selectBarcodeNumberObj = params.row; // 点击了哪一行数据
                                        this.copyTableData = this.copyData(this.tableData); // 备份送货单数据
                                        this.queryCanMatchReportHeader('1');
                                    }
                                }
                            }),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: !params.row.reportNumbers
                                },
                                style: {
                                    width: '60px',
                                    marginLeft: '2px'
                                },
                                on: {
                                    'click': () => {
                                        this.selectBarcodeNumberObj = params.row;
                                        this.resetMatchReport(params.row.reportNumber);
                                    }
                                }
                            }, this.$t('清空'))
                        ]);
                    }
                },
                {
                    title: this.$t('已匹配报告数量'),
                    key: 'usableQuantity',
                    align: 'right',
                    width: 100
                },
                {
                    title: this.$t('批次号'),
                    key: 'productBatch2',
                    width: 150
                }
            ],
            tableColumns2: [
                {
                    type: 'selection',
                    align: 'center',
                    width: 35
                },
                {
                    renderHeader: (h, params) => {
                        return h('div', {}, [
                            h('Row', {
                                style: {
                                    height: '28px',
                                    lineHeight: '28px'
                                }
                            }, [
                                h('Input', {
                                    props: {
                                        size: 'small',
                                        value: this.tempObj.reportNumber
                                    },
                                    on: {
                                        'on-change': (evnet) => {
                                            this.tempObj.reportNumber = event.target.value;
                                            this.filterData();
                                        }
                                    }
                                })
                            ]),
                            h('Row', {
                                style: {
                                    height: '20px',
                                    lineHeight: '19px'
                                }
                            }, [
                                h('div', {}, this.$t('批次检验单号'))
                            ])]);
                    },
                    title: this.$t('批次检验单号'),
                    key: 'reportNumber',
                    width: 140
                },
                {
                    renderHeader: (h, params) => {
                        return h('div', {}, [
                            h('Row', {
                                style: {
                                    height: '28px',
                                    lineHeight: '28px'
                                }
                            }, [
                                h('Input', {
                                    props: {
                                        size: 'small',
                                        value: this.tempObj.batchNumber
                                    },
                                    on: {
                                        'on-change': (evnet) => {
                                            this.tempObj.batchNumber = event.target.value;
                                            this.filterData();
                                        }
                                    }
                                })
                            ]),
                            h('Row', {
                                style: {
                                    height: '20px',
                                    lineHeight: '19px'
                                }
                            }, [
                                h('div', {}, this.$t('批次号'))
                            ])]);
                    },
                    title: this.$t('批次号'),
                    key: 'batchNumber',
                    width: 100
                },
                {
                    title: this.$t('生产数量'),
                    key: 'checkQuantity',
                    align: 'right',
                    width: 60
                },
                {
                    title: this.$t('可用数量'),
                    key: 'usableQuantity',
                    align: 'right',
                    width: 60
                },
                {
                    title: this.$t('有效日期从'),
                    key: 'validStartTime',
                    width: 140
                },
                {
                    title: this.$t('有效日期至'),
                    key: 'validEndTime',
                    width: 140
                },
                {
                    title: this.$t('送货单条码号'),
                    minWidth: 300,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', {
                            attrs: {
                                title: params.row.matchBarcodeNumbers
                            },
                            style: {
                                display: 'flex'
                            },
                        }, [
                            h('Input', {
                                props: {
                                    icon: 'search',
                                    value: params.row.matchBarcodeNumbers,
                                    size: 'small',
                                    readonly: true
                                },
                                style: {
                                    width: '260px'
                                },
                                on: {
                                    'on-click': () => {
                                        this.selectAll = false;
                                        this.modalTableReload();
                                        this.Modal2 = true;
                                        this.copyTableData = this.copyData(this.tableData); // 备份报告数据
                                        this.tempModalData2 = this.copyData(this.ModalData2); // 临时保存原数据(用于取消时可还原数据)
                                        this.selectReportObj = params.row;
                                        this.selectDeliveryCount = 0;
                                        this.searchDelivery(params.row);
                                    }
                                }
                            }),
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: !params.row.matchBarcodeNumbers
                                },
                                style: {
                                    width: '60px',
                                    marginLeft: '2px'
                                },
                                on: {
                                    'click': () => {
                                        this.selectReportObj = params.row;
                                        this.resetMatchDelivery(params.row.reportNumber);
                                    }
                                }
                            }, this.$t('清空'))
                        ]);
                    }
                },
                {
                    title: this.$t('事业部'),
                    key: 'buName',
                    align: 'center',
                    minWidth: 140,
                    tooltip: true
                },
                {
                    title: this.$t('检验标准'),
                    key: 'groupFlagName',
                    align: 'center',
                    width: 100
                }
            ],
            Modal1: false,
            ModalColumns1: [
                {
                    title: this.$t('勾选'),
                    width: 35,
                    align: 'center',
                    render: (h, params) => {
                        return h('Checkbox', {
                            props: {
                                value: params.row.hasSelected
                            },
                            on: {
                                'on-change': (selection) => {
                                    let row = params.row;
                                    this.reportMatch(selection, row, params);
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$t('批次检验单号'),
                    key: 'reportNumber',
                    width: 140
                },
                {
                    title: this.$t('批次号'),
                    key: 'batchNumber',
                    width: 110
                },
                {
                    title: this.$t('生产数量'),
                    key: 'checkQuantity',
                    align: 'right',
                    width: 80
                },
                {
                    title: this.$t('可用数量'),
                    key: 'usableQuantityTemp',
                    align: 'right',
                    width: 80
                },
                {
                    title: this.$t('匹配数量'),
                    key: 'matchQuantity',
                    align: 'right',
                    width: 80,
                    render: (h, params) => {
                        if (params.row.matchQuantity) {
                            return h('span', params.row.matchQuantity);
                        }
                    }
                },
                {
                    title: this.$t('有效日期从'),
                    key: 'validStartTime',
                    minWidth: 140
                },
                {
                    title: this.$t('有效日期至'),
                    key: 'validEndTime',
                    minWidth: 140
                },
                {
                    title: this.$t('事业部'),
                    key: 'buName',
                    align: 'center',
                    minWidth: 140,
                    tooltip: true
                },
                {
                    title: this.$t('检验标准'),
                    key: 'groupFlagName',
                    align: 'center',
                    width: 100
                }
            ],
            ModalData1: [],
            Modal2: false,
            canSelectionAll: false,
            selectAll: false,
            ModalColumns2: [
                {
                    title: this.$t('勾选'),
                    width: 35,
                    align: 'center',
                    renderHeader: (h, params) => {
                        // if (this.canSelectionAll) {
                            return h('Checkbox', {
                                props: {
                                    value: this.selectAll
                                },
                                on: {
                                    'on-change': (selection) => {
                                        this.changeAllDeliverySelect(selection);
                                    }
                                }
                            });
                        // } else {
                        //     return h('span', '勾选');
                        // }
                    },
                    render: (h, params) => {
                        return h('Checkbox', {
                            props: {
                                value: params.row.hasSelected
                            },
                            on: {
                                'on-change': (selection) => {
                                    this.deliveryMatch(selection, params.row, params);
                                }
                            }
                        });
                    }
                },
                {
                    title: this.$t('送货单条码号'),
                    key: 'barcodeNumber',
                    minWidth: 120
                },
                {
                    title: this.$t('送货单号'),
                    key: 'deliveryNumber',
                    width: 130
                },
                {
                    title: this.$t('送货数量'),
                    key: 'deliveryQuantity',
                    align: 'right',
                    width: 100
                },
                {
                    title: this.$t('匹配数量'),
                    key: 'matchQuantity',
                    align: 'right',
                    width: 80
                },
                {
                    title: this.$t('需求日期'),
                    key: 'needByDate',
                    width: this.isOutOrder ? 0 : 150
                }
            ],
            ModalData2: [],
            tempData: {},
            selectBarcodeNumberObj: {},
            selectReportObj: {},
            modalTableShow: true,
            copyTableData: [],
            copyModalData1: [], // 备份报告匹配表格数据
            tempModalData1: [], // 临时保存报告匹配表格数据
            copyModalData2: [], // 备份送货单匹配表格数据
            tempModalData2: [], // 临时保存送货单匹配表格数据
            selectDeliveryCount: 0, // 送货单送货数量合计
            submitSelection: [], // 勾选数据
            NEW_DELIVERY_REMINDER_ORG: [],
            orgData: [],
            selectMatch: []
        };
    },
    watch: {
        ModalData1: {
            handler (val) {
                this.updateCopy(val);
            },
            deep: true
        },
        ModalData2: {
            handler (val) {
                this.updateCopy2(val);
            },
            deep: true
        },
        '$route' (newVal, oldVal) {
            if (newVal.name === 'orderMatchReport') {
                let itemCode = newVal.query.itemCode;
                if (this.beforeItemCode) {
                    if (this.beforeItemCode !== itemCode) {
                        this.releaseLock(this.beforeItemCode, true);
                    }
                }
            }
        }
    },
    methods: {
        getOverSeaBuList() {
            axios.get('/gscint/vendor/getOverSeaBuList', {
                params: {
                    SITE: 'Y',
                    ASL: 'N',
                    UP: 'Y',
                    orgCode: this.tempData.orgCode,
                    vendorCode: this.vendorCode,
                }
            }).then((res) => {
                let { datas = [] } = res.data.data
                this.orgData = datas || []
            }).catch(() => {
            });
        },
        onSubmit () {
            let type = this.getFormDataItemVal(this.formData.items, 'matchType');
            let array = [];
            let newArray = [];
            this[`ModalData${type}`] = [];
            this[`copyModalData${type}`] = [];
            this[`tempModalData${type}`] = [];
            array = this.copyData(this[`tableData${type}`]);
            if (type === '1') {
                array.map((item) => {
                    newArray.push({
                        ...item,
                        usableQuantity: 0,
                        reportNumbers: '',
                        matchReportList: [],
                        productBatch2Copy: item.productBatch2
                    });
                });
                // 合并相同物料的送货单
                let list = this.mergeSameDelivery(newArray);
                this.tableData = list;
            } else {
                this.queryCanMatchReportHeader('2');
            }
            this.submitSelection = [];
        },
        // 查询可用于匹配的检验报告
        queryCanMatchReportHeader (matchType) {
            this.loading = true;
            this.ModalData1 = [];
            axios.get('/gscint/sxInspection/queryCanMatchReportHeader', {
                params: {
                    itemCode: this.tempData.itemCode,
                    orgCode: this.tempData.orgCode,
                    vendorCode: this.vendorCode
                }
            })
            .then((res) => {
                this.loading = false;
                let list = res.data.data.datas
                console.log('list',list)
                if (list.length > 0) {
                    // 匹配模式是否为按送货单模式
                    if (matchType == '1') {
                        list.map((item, index) => {
                            list[index].matchBarcodeNumbers = [];
                            list[index].usableQuantityTemp = item.usableQuantity;
                            list[index].matchQuantity = 0;
                            this.copyModalData1.map((item2) => {
                                if (item.reportNumber === item2.reportNumber) {
                                    list[index].matchBarcodeNumbers = item2.matchBarcodeNumbers;
                                    list[index].usableQuantityTemp = item2.usableQuantityTemp;
                                    list[index].matchQuantity = this.operation(item2.usableQuantity, item2.usableQuantityTemp, 'subtract');
                                }
                            });
                        });
                        this.copyModalData1 = this.copyData(list);
                        this.tempModalData1 = this.copyData(list); // 临时保存原数据(用于取消时可还原数据)
                        // this.ModalData1 = list.filter((item) => item.usableQuantityTemp > 0 && !item.matchBarcodeNumbers.includes(this.selectBarcodeNumberObj.barcodeNumber));
                        this.ModalData1 = list //.filter((item) => item.usableQuantityTemp > 0 && !item.matchBarcodeNumbers.includes(this.selectBarcodeNumberObj.barcodeNumber));
                    } else {
                        let newArray = [];
                        list.map((item) => {
                            newArray.push({
                                ...item,
                                matchDeliveryList: [],
                                matchBarcodeNumbers: ''
                            });
                        });
                        this.tableData2 = newArray;
                        this.tableData = this.copyData(newArray);
                        this.allFilterTableData = this.copyData(newArray);
                    }
                    console.log('ModalData1', this.ModalData1)
                }
            })
            .catch(() => {
                if (matchType === '2') {
                    this.tableData2 = [];
                    this.tableData = [];
                }
                this.showErrorTips();
            });
        },
        // 匹配报告
        reportMatch (selection, row, params) {
            let newSelection = false;
            let reLoad = false;
            let deliveryObj = this.selectBarcodeNumberObj;
            let usableQuantity = 0; // 本次匹配数量
            let usableQuantityTemp = row.usableQuantityTemp; // 报告剩余可用数量
            if (selection) {
                // 当送货数量是否大于匹配数量时
                if (parseFloat(deliveryObj.deliveryQuantity) <= deliveryObj.usableQuantity) {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('此送货单已没有需匹配的送货数量')
                    });
                    reLoad = true;
                } else {
                    // 报告可用数量是否大于0
                    if (row.usableQuantityTemp > 0) {
                        newSelection = true;
                        this.reportMatchUpdate(row, deliveryObj, params, usableQuantityTemp, usableQuantity, 'add');
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('该报告已没有可用数量')
                        });
                        reLoad = true;
                    }
                }
            } else {
                /* 取消匹配 */
                this.reportMatchUpdate(row, deliveryObj, params, usableQuantityTemp, usableQuantity, 'reduce');
            }
            this.$set(this.ModalData1[params.index], 'hasSelected', newSelection);
            if (reLoad) {
                this.modalTableReload();
            }
        },
        // 表格强刷
        modalTableReload () {
            this.modalTableShow = false;
            setTimeout(() => {
                this.modalTableShow = true;
            }, 0);
        },
        // 匹配报告更新数据
        reportMatchUpdate (row, deliveryObj, params, usableQuantityTemp, usableQuantity, type) {
            if (type === 'add') {
                // 勾选的报告数量 + 已匹配数量 是否大于送货数量
                // 可用数量 + 送货单已匹配数量 是否大于 送货单送货数量
                if (this.operation(row.usableQuantityTemp, deliveryObj.usableQuantity, 'add') > parseFloat(deliveryObj.deliveryQuantity)) {
                    usableQuantity = this.operation(parseFloat(deliveryObj.deliveryQuantity), deliveryObj.usableQuantity, 'subtract');
                    usableQuantityTemp = this.operation(row.usableQuantityTemp, usableQuantity, 'subtract');
                } else {
                    usableQuantity = row.usableQuantityTemp;
                    usableQuantityTemp = 0;
                }
                this.tableData.map((item, index) => {
                    if (item.barcodeNumber === deliveryObj.barcodeNumber) {
                        let newArray = this.tableData[index].reportNumbers.split(',');
                        newArray.push(row.reportNumber);
                        let reportNumbers = [];
                        newArray.map((item) => {
                            if (item) {
                                reportNumbers.push(item);
                            }
                        });
                        this.tableData[index].usableQuantity = this.operation(this.tableData[index].usableQuantity, usableQuantity, 'add');
                        this.tableData[index].reportNumbers = reportNumbers.join();
                        this.tableData[index].productBatch2 += `,${row.batchNumber}`;
                        this.tableData[index].matchReportList.push({
                            reportNumber: row.reportNumber,
                            usableQuantity
                        });
                        this.selectBarcodeNumberObj = this.tableData[index];
                    }
                });
                this.ModalData1[params.index].matchBarcodeNumbers.push(deliveryObj.barcodeNumber);
                this.ModalData1[params.index].matchQuantity = this.operation(this.ModalData1[params.index].matchQuantity, usableQuantity, 'add')
            } else {
                let matchBarcodeNumbers = [];
                let matchReportList = [];
                let reportNumbers = [];
                let cancelusableQuantity = 0; // 本次取消数量
                this.tableData.map((item, index) => {
                    if (item.barcodeNumber === deliveryObj.barcodeNumber) {
                        this.tableData[index].matchReportList.map((item) => {
                            if (item.reportNumber !== row.reportNumber) {
                                matchReportList.push({
                                    ...item
                                });
                            } else {
                                usableQuantityTemp = this.operation(usableQuantityTemp, item.usableQuantity, 'add');
                                cancelusableQuantity = item.usableQuantity;
                            }
                        });
                        this.tableData[index].reportNumbers.split(',').map((item) => {
                            if (item !== row.reportNumber) {
                                reportNumbers.push(item);
                            }
                        });
                        let productBatch2 = this.tableData[index].productBatch2.split(',');
                        this.tableData[index].productBatch2 = productBatch2.filter((item) => item !== row.batchNumber).join();
                        this.tableData[index].matchReportList = matchReportList;
                        this.tableData[index].reportNumbers = reportNumbers.join();
                        this.selectBarcodeNumberObj = this.tableData[index];
                        this.tableData[index].usableQuantity = this.operation(this.tableData[index].usableQuantity, cancelusableQuantity, 'subtract');
                    }
                });
                this.ModalData1[params.index].matchBarcodeNumbers.map((item) => {
                    if (item !== deliveryObj.barcodeNumber) {
                        matchBarcodeNumbers.push(item);
                    }
                });
                this.ModalData1[params.index].matchBarcodeNumbers = matchBarcodeNumbers;
                this.ModalData1[params.index].matchQuantity = this.operation(row.usableQuantity, usableQuantityTemp, 'subtract');
            }
            this.$set(this.ModalData1[params.index], 'usableQuantityTemp', usableQuantityTemp);
        },
        // 送货单匹配
        deliveryMatch (selection, row, params) {
            // row 是送货单数据， tableData是 报告数据
            let reportObj = this.selectReportObj;
            let newSelection = false;
            let reLoad = false;
            let usableQuantity = reportObj.usableQuantity; // 报告的可用数量
            let matchQuantity = row.matchQuantity; // 送货单已匹配的数量
            let residuematchQuantity = this.operation(row.deliveryQuantity, matchQuantity, 'subtract'); // 送货单剩余需要匹配的数量
            if (selection) {
                // 判断报告可用数量是否大于送货数量
                if (usableQuantity >= row.deliveryQuantity) {
                    this.selectDeliveryCount = this.operation(this.selectDeliveryCount, residuematchQuantity, 'add');
                    newSelection = true;
                    // 更新数据
                    this.deliveryMatchUpdate(reportObj, residuematchQuantity, row, 'add');
                } else {
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('当前送货合计数量大于此批次出货检验报告的可用数量，请修改')
                    });
                    reLoad = true;
                }
            } else {
                this.selectDeliveryCount = this.operation(this.selectDeliveryCount, matchQuantity, 'subtract');
                this.deliveryMatchUpdate(reportObj, matchQuantity, row, 'reduce');
            }
            this.$set(this.ModalData2[params.index], 'hasSelected', newSelection);
            if (reLoad) {
                this.modalTableReload();
            }
        },
        // 送货单匹配更新数据
        deliveryMatchUpdate (reportObj, residuematchQuantity, row, type) {
            let matchReportList = [];
            this.tableData.map((item, index) => {
                if (item.reportNumber === reportObj.reportNumber) {
                    // reportObj.usableQuantity = item.usableQuantity;
                    let newArray = this.tableData[index].matchBarcodeNumbers ? this.tableData[index].matchBarcodeNumbers.split(',') : [];
                    let matchDeliveryList = this.tableData[index].matchDeliveryList;
                    let usableQuantity = reportObj.usableQuantity;
                    let matchBarcodeNumbers = [];
                    if (type === 'add') {
                        matchDeliveryList.push({
                            barcodeNumber: row.barcodeNumber,
                            matchQuantity: residuematchQuantity
                        });
                        newArray.push(row.barcodeNumber);
                        matchBarcodeNumbers = newArray.join();
                        usableQuantity = this.operation(usableQuantity, residuematchQuantity, 'subtract');
                        matchReportList.push(reportObj.reportNumber);
                    } else {
                        matchDeliveryList = matchDeliveryList.filter((item) => item.barcodeNumber !== row.barcodeNumber);
                        matchBarcodeNumbers = newArray.filter((item) => item !== row.barcodeNumber).join();
                        usableQuantity = this.operation(usableQuantity, residuematchQuantity, 'add');
                        matchReportList = [];
                    }
                    let updateObj = {
                        ...item,
                        matchBarcodeNumbers,
                        matchDeliveryList,
                        usableQuantity
                    };
                    this.$set(this.tableData, index, updateObj);
                    this.selectReportObj = updateObj;
                    // reportObj = this.tableData[index];
                }
            });
            this.ModalData2.map((item, index) => {
                if (item.barcodeNumber === row.barcodeNumber) {
                    this.$set(this.ModalData2, index, {
                        ...item,
                        'matchQuantity': type === 'add' ? this.operation(item.matchQuantity, residuematchQuantity, 'add') : (this.operation(item.matchQuantity, row.deliveryQuantity, 'subtract') > 0 ? this.operation(item.matchQuantity, row.deliveryQuantity, 'subtract') : 0),
                        matchReportList
                    });
                }
            });
        },
        // 确定匹配报告
        confirmReportSelect () {
            let deliveryObj = this.selectBarcodeNumberObj;
            let deliveryQuantity = deliveryObj.deliveryQuantity;
            let usableQuantity = 0;
            this.tableData.map((item, index) => {
                if (item.barcodeNumber === deliveryObj.barcodeNumber) {
                    item.matchReportList.map((item2) => {
                        usableQuantity = this.operation(usableQuantity, item2.usableQuantity, 'add');
                    });
                }
            });
            if (usableQuantity < deliveryQuantity) {
                this.showErrorTips('loading', this.$t('当前批次报告匹配数量小于送货数量，请修改'));
                return false;
            }
            this.Modal1 = false;
        },
        // 确认匹配送货单
        confirmDeliverSelect () {
            this.Modal2 = false;
        },
        // 取消匹配报告
        cancelReportSelect () {
            this.Modal1 = false;
            this.tableData = this.copyData(this.copyTableData);
            this.ModalData1 = this.copyData(this.tempModalData1);
        },
        // 取消匹配送货单
        cancelDeliverySelect () {
            this.selectDeliveryCount = 0;
            this.Modal2 = false;
            this.tableData = this.copyData(this.copyTableData);
            // this.ModalData2 = this.copyData(this.tempModalData2);
            this.changeAllDeliverySelect(false);
        },
        changeAllDeliverySelect (selection) {
            // 全选之前先清除原来的匹配
            if (selection) {
                this.selectDeliveryCount = 0;
                this.resetMatchDelivery(this.selectReportObj.reportNumber);
            }
            this.ModalData2.map((item, index) => {
                this.deliveryMatch(selection, item, {index});
            });
        },
        // 清空已匹配的报告
        resetMatchReport (reportNumber) {
            let deliveryObj = this.selectBarcodeNumberObj;
            let matchReportListObj = {};
            this.tableData.map((item, index) => {
                if (item.barcodeNumber === deliveryObj.barcodeNumber) {
                    item.matchReportList.map((item) => {
                        matchReportListObj[item.reportNumber] = item.usableQuantity;
                    });
                    this.$set(this.tableData, index, {
                        ...item,
                        usableQuantity: 0,
                        matchReportList: [],
                        reportNumbers: '',
                        productBatch2: item.productBatch2Copy
                    });
                }
            });
            this.copyModalData1.map((item, index) => {
                let barcodeNumbers = [];
                item.matchBarcodeNumbers.map((barcodeNumber) => {
                    if (barcodeNumber !== deliveryObj.barcodeNumber) {
                        barcodeNumbers.push(barcodeNumber);
                    }
                });
                this.copyModalData1[index].matchBarcodeNumbers = barcodeNumbers;
                for (let key in matchReportListObj) {
                    if (item.reportNumber === key) {
                        this.copyModalData1[index].usableQuantityTemp = this.operation(item.usableQuantityTemp, matchReportListObj[key], 'add');
                    }
                }
            });
            this.ModalData1 = this.copyData(this.copyModalData1);
            this.submitSelection = [];
        },
        // 清空已匹配的送货单
        resetMatchDelivery (reportNumber) {
            let reportObj = this.selectReportObj;
            let matchDeliveryListObj = {};
            let matchQuantity = 0;
            this.tableData.map((item, index) => {
                if (item.reportNumber === reportObj.reportNumber) {
                    item.matchDeliveryList.map((item) => {
                        matchDeliveryListObj[item.barcodeNumber] = item.matchQuantity;
                        matchQuantity = this.operation(matchQuantity, item.matchQuantity, 'add');
                    });
                    this.$set(this.tableData, index, {
                        ...item,
                        matchQuantity: 0,
                        usableQuantity: item.usableQuantity = this.operation(item.usableQuantity, matchQuantity, 'add'),
                        matchDeliveryList: [],
                        matchBarcodeNumbers: ''
                    });
                }
            });
            this.copyModalData2.map((item, index) => {
                if (item.matchReportList.includes(reportObj.reportNumber)) {
                    let matchQuantity = item.matchQuantity;
                    this.copyModalData2[index].matchReportList = item.matchReportList.filter((item) => item !== reportObj.reportNumber);
                    this.copyModalData2[index].matchQuantity = this.operation(matchQuantity, matchDeliveryListObj[item.barcodeNumber], 'subtract');
                }
            });
            this.ModalData2 = this.copyData(this.copyModalData2);
            this.submitSelection = [];
        },
        // 查询用用于匹配的送货单
        searchDelivery (row) {
            let list = [];
            this.tableData1.map((item) => {
                list.push({
                    ...item,
                    matchReportList: [],
                    matchQuantity: 0
                });
            });
            if (this.copyModalData2.length === 0) {
                this.copyModalData2 = this.copyData(list);
            } else {
                this.copyModalData2.map((item) => {
                    list.map((item2, index) => {
                        if (item.barcodeNumber === item2.barcodeNumber) {
                            list[index].matchReportList = item.matchReportList;
                            list[index].matchQuantity = item.matchQuantity;
                        }
                    });
                });
            }
            this.ModalData2 = list.filter((item) => item.matchReportList.length === 0);
            let deliveryQuantity = 0;
            this.ModalData2.map((item) => {
                deliveryQuantity = this.operation(deliveryQuantity, parseFloat(item.deliveryQuantity), 'add');
            });
            row.usableQuantity >= deliveryQuantity ? this.canSelectionAll = true : this.canSelectionAll = false;
        },
        copyData (obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        // 更新备份
        updateCopy (obj) {
            if (obj.length > 0) {
                obj.map((item) => {
                    this.copyModalData1.map((item2, index) => {
                        if (item.reportNumber === item2.reportNumber) {
                            this.copyModalData1[index] = {
                                ...item2,
                                matchBarcodeNumbers: item.matchBarcodeNumbers,
                                usableQuantityTemp: item.usableQuantityTemp
                            };
                        }
                    });
                });
                this.submitSelection = [];
            }
        },
        updateCopy2 (obj) {
            if (obj.length > 0) {
                obj.map((item) => {
                    this.copyModalData2.map((item2, index) => {
                        if (item.barcodeNumber === item2.barcodeNumber) {
                            this.$set(this.copyModalData2, index, {
                                ...item2,
                                matchQuantity: item.matchQuantity ? item.matchQuantity : 0,
                                matchReportList: item.matchReportList
                            });
                        };
                    });
                });
                this.submitSelection = [];
            }
        },
        // 勾选数据
        onSelectionChange (selection) {
            this.submitSelection = selection;
        },
        dataLog () {
            console.log(`${this.chooseType}`, this[`${this.chooseType}`]);
        },
        // 匹配提交
        async reportOrderMatch () {
            let matchType = this.getFormDataItemVal(this.formData.items, 'matchType');
            let isError = false;
            let detailList = [];
            let barcodeNumbers = [];
            let key = '';
            let key2 = '';
            let deliveryObj = {};
            if (matchType === '1') {
                // 按送货单匹配
                key = 'barcodeNumber';
                key2 = 'matchReportList';
            } else {
                // 按批次报告匹配
                key = 'reportNumber';
                key2 = 'matchDeliveryList';
                this.copyModalData2.map((item) => {
                    deliveryObj[item.barcodeNumber] = item.deliveryLineId;
                });
            }
            this.submitSelection.map((item) => {
                this.tableData.map((item2) => {
                    if (item[key] === item2[key]) {
                        if (item2[key2].length === 0) {
                            isError = true;
                        }
                    }
                });
            });
            if (isError) {
                this.showErrorTips('loading', matchType === '1' ? this.$t('请选择批次检验单号') : this.$t('请选择送货单条码号'));
                return false;
            }
            this.submitSelection.map((item) => {
                this.tableData.map((item2) => {
                    if (item[key] === item2[key]) {
                        item2[key2].map((item3) => {
                            detailList.push({
                                deliveryLineId: matchType === '1' ? item2.deliveryLineId : deliveryObj[item3.barcodeNumber],
                                reportNumber: matchType === '1' ? item3.reportNumber : item2.reportNumber,
                                matchQuantity: matchType === '1' ? item3.usableQuantity : item3.matchQuantity,
                                barcodeNumber: matchType === '1' ? item2.barcodeNumber : item3.barcodeNumber,
                                itemCode: item2.itemCode,
                            });
                        });
                        barcodeNumbers.push(item2.barcodeNumber);
                    }
                });
            });
            // 判断是否有相同送货单号的数据，处理完成后重新返回新的数据
            detailList = this.handlerDetailList(detailList);
            this.loading = true;
            let buCode = this.orgData.length ? this.orgData[0].buCode : ''
            axios.post('/gscint/sxInspection/reportOrderMatch', {
                requestId: new Date().getTime(),
                itemCode: this.tempData.itemCode,
                vendorCode: this.vendorCode,
                buCode: buCode,
                detailList: detailList,
            })
            .then((res) => {
                this.loading = false;
                this.loading = false;
                const { code, msg } = res.data.data;
                if (code === '1') {
                    this.$Modal.success({
                        content: this.$t('processInspectionSearch.t69'),
                    });
                    this.$closeTab({
                        name: 'processInspectionMatch',
                    });
                    setTimeout(() => {
                        this.$router.push({
                            name: 'DeliveryOrderQuery',
                        });
                    }, 500)
                } else {
                    this.$Modal.error({
                        content: msg,
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        // 合并的送货单重新拆分匹配
        handlerDetailList (detailList) {
            let deliveryLineIdList = [];
            let barcodeNumberList = [];
            let barcodeNumberObj = {};
            detailList.map((item) => {
                deliveryLineIdList.push(item.deliveryLineId);
            });
            deliveryLineIdList = Array.from(new Set(deliveryLineIdList));
            this.tempData.list.map((item) => {
                if (deliveryLineIdList.includes(item.deliveryLineId)) {
                    barcodeNumberList.push(item.barcodeNumber);
                }
            });
            this.tempData.list.map((item) => {
                if (barcodeNumberList.includes(item.barcodeNumber)) {
                    if (barcodeNumberObj[item.barcodeNumber]) {
                        barcodeNumberObj[item.barcodeNumber].deliveryLineId.push(item.deliveryLineId);
                        barcodeNumberObj[item.barcodeNumber].delivery.push({
                            deliveryLineId: item.deliveryLineId,
                            deliveryQuantity: parseFloat(item.deliveryQuantity)
                        });
                    } else {
                        barcodeNumberObj[item.barcodeNumber] = {
                            deliveryLineId: [item.deliveryLineId],
                            delivery: [{
                                deliveryLineId: item.deliveryLineId,
                                deliveryQuantity: parseFloat(item.deliveryQuantity)
                            }],
                            detailList: []
                        };
                    }
                }
            });
            for (let i in barcodeNumberObj) {
                detailList.map((item) => {
                    if (barcodeNumberObj[i].deliveryLineId.includes(item.deliveryLineId)) {
                        if (!barcodeNumberObj[i].reportNumber) {
                            barcodeNumberObj[i].reportNumber = [{
                                matchQuantity: item.matchQuantity,
                                reportNumber: item.reportNumber
                            }];
                        } else {
                            barcodeNumberObj[i].reportNumber.push({
                                matchQuantity: item.matchQuantity,
                                reportNumber: item.reportNumber
                            });
                        }
                    }
                });
            }
            let list = [];
            for (let i in barcodeNumberObj) {
                barcodeNumberObj[i] = this.calculateData(barcodeNumberObj[i]);
                list = list.concat(barcodeNumberObj[i].detailList);
            }
            return list;
        },
        // 计算匹配
        calculateData (obj) {
            for (let i in obj.delivery) {
                for (let j in obj.reportNumber) {
                    let deliveryQuantity = obj.delivery[i].deliveryQuantity;
                    if (deliveryQuantity) {
                        // 判断送货数量是否大于匹配数量
                        if (deliveryQuantity <= obj.reportNumber[j].matchQuantity) {
                            if (deliveryQuantity) {
                                obj.detailList.push({
                                    deliveryLineId: obj.delivery[i].deliveryLineId,
                                    matchQuantity: deliveryQuantity,
                                    reportNumber: obj.reportNumber[j].reportNumber
                                });
                            }
                            obj.reportNumber[j].matchQuantity = this.operation(obj.reportNumber[j].matchQuantity, deliveryQuantity, 'subtract');
                            obj.delivery[i].deliveryQuantity = 0;
                        } else {
                            let matchQuantity = obj.reportNumber[j].matchQuantity;
                            if (matchQuantity) {
                                obj.detailList.push({
                                    deliveryLineId: obj.delivery[i].deliveryLineId,
                                    matchQuantity,
                                    reportNumber: obj.reportNumber[j].reportNumber
                                });
                            }
                            obj.delivery[i].deliveryQuantity = this.operation(obj.delivery[i].deliveryQuantity, matchQuantity, 'subtract');
                            obj.reportNumber[j].matchQuantity = 0;
                        }
                    }
                }
            }
            return obj;
        },
        // 解锁
        // releaseLock (itemCode, cannotRemove) {
        //     try {
        //         let xhr = new XMLHttpRequest();
        //         xhr.open('GET', `/gscapp/distributedLock/releaseLock?lockKey=${this.vendorCode}${this.tempData.buName},${itemCode || this.tempData.itemCode}&lockValue=${this.tempData.buName},${itemCode || this.tempData.itemCode}`, false);
        //         xhr.send(null);
        //         if (!cannotRemove) {
        //             sessionStorage.removeItem('orderMatchReport');
        //         }
        //         localStorage.setItem('releaseLock', new Date().getTime());
        //     } catch (err) {
        //         console.log(err);
        //     }
        // },
        /** 过滤数据（本地模糊查询） */
        filterData (isVague, type, time, isTimeArray) {
            let copyTableData = this.copyData(this.allFilterTableData);
            for (let key in this.tempObj) {
                if (this.tempObj[key]) {
                    copyTableData = this.vagueSearch(key, this.tempObj[key], copyTableData, isVague === false ? isVague : true, (key === 'scheduledStartDate' || key === 'needByDate' ? 'time' : 'input'), time, isTimeArray);
                }
            }
            this.tableData = copyTableData;
            this.submitSelection = [];
            this.tableData.map((item) => {
                this.resetMatchDelivery(item.reportNumber);
            });
        },
        /** 正则模糊查询 */
        vagueSearch (key, val, table, isVague, type, time, isTimeArray) {
            let newArr = [];
            let reg = new RegExp(val);
            for (let i = 0; i < table.length; i++) {
                if (type !== 'time') {
                    if (isVague) {
                        if ((table[i][key] + '').match(reg)) {
                            newArr.push(table[i]);
                        }
                    } else {
                        if (table[i][key].toString() === val) {
                            newArr.push(table[i]);
                        }
                    }
                }
            }
            return newArr;
        },
        getBuList () {
            axios.post('/gscapp/inspectionReport/queryBu', {
                UP: 'Y',
                SITE: 'Y',
                ASL: 'N',
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.buList = res.data.data.datas;
            });
        },
        constraintReleaseLock () {
            axios.get('/gscapp/distributedLock/releaseLock', {
                params: {
                    lockKey: `${this.vendorCode}${this.releaseLockObj.buName},${this.releaseLockObj.itemCode}`,
                    lockValue: `${this.releaseLockObj.buName},${this.releaseLockObj.itemCode}`
                }
            });
        },
        // 合并相同物料的送货单
        mergeSameDelivery (list) {
            let sameObj = {};
            list.map((item) => {
                if (sameObj[item.barcodeNumber + item.itemCode]) {
                    sameObj[item.barcodeNumber + item.itemCode] = {
                        ...item,
                        deliveryQuantity: this.operation(parseFloat(item.deliveryQuantity), parseFloat(sameObj[item.barcodeNumber + item.itemCode].deliveryQuantity), 'add')
                    };
                } else {
                    sameObj[item.barcodeNumber + item.itemCode] = item;
                }
            });
            let newList = [];
            for (let i in sameObj) {
                newList.push({
                    ...sameObj[i],
                    productBatch2: ''
                });
            }
            return newList;
        },
        // 判断是否外租仓送货单
        checkIsOutOrder (list) {
            if (this.isOutOrder) {
                list.map((item, index) => {
                    list[index].deliveryQuantity = list[index].shipmentQty;
                    list[index].deliveryNumber = list[index].billNumber;
                    list[index].deliveryLineId = list[index].billLineId;
                });
            }
            return list;
        },
        // 精度问题处理
        isInteger (obj) {
            return Math.floor(obj) === obj;
        },
        toInteger (floatNum) {
            let ret = {
                times: 1,
                num: 0
            };
            if (this.isInteger(floatNum)) {
                ret.num = floatNum;
                return ret;
            }
            let strfi = floatNum + '';
            let dotPos = strfi.indexOf('.');
            let len = strfi.substr(dotPos + 1).length;
            let times = Math.pow(10, len);
            let intNum = parseInt(floatNum * times + 0.5, 10);
            ret.times = times;
            ret.num = intNum;
            return ret
        },
        // 通用方法
        operation (a, b, op) {
            let o1 = this.toInteger(a);
            let o2 = this.toInteger(b);
            let n1 = o1.num;
            let n2 = o2.num;
            let t1 = o1.times;
            let t2 = o2.times;
            let max = t1 > t2 ? t1 : t2;
            let result = null;
            switch (op) {
                case 'add':
                    if (t1 === t2) { // 两个小数位数相同
                        result = n1 + n2
                    } else if (t1 > t2) { // o1 小数位 大于 o2
                        result = n1 + n2 * (t1 / t2)
                    } else { // o1 小数位 小于 o2
                        result = n1 * (t2 / t1) + n2
                    }
                    return result / max;
                case 'subtract':
                    if (t1 === t2) {
                        result = n1 - n2
                    } else if (t1 > t2) {
                        result = n1 - n2 * (t1 / t2)
                    } else {
                        result = n1 * (t2 / t1) - n2
                    }
                    return result / max;
                case 'multiply':
                    result = (n1 * n2) / (t1 * t2);
                    return result;
                case 'divide':
                    result = (n1 / n2) * (t2 / t1);
                    return result
            }
        },
        /* 监控回车事件，自动确认 */
        handKeyCode ({keyCode}) {
            if (keyCode === 13 && this.submitSelection.length > 0) {
                this.reportOrderMatch();
            }
        }

    },
    activated () {
        let tempData = JSON.parse(sessionStorage.getItem('orderMatchReport'));
        // 合并相同物料的送货单
        let list = this.mergeSameDelivery(this.checkIsOutOrder(tempData.list));
        this.tempData = tempData;
        let urlQuery = this.$route.query;
        if (tempData.orgId === urlQuery.orgId && tempData.itemCode === urlQuery.itemCode) {
            let matchType = this.getFormDataItemVal(this.formData.items, 'matchType');
            if (matchType === '1') {
                this.columns.columns = this.tableColumns1.filter((item) => !item.hide);
            } else {
                this.columns.columns = this.tableColumns2.filter((item) => !item.hide);
            }
            this.tableData1 = this.copyData(list);
            this.tableData2 = this.copyData(list);
            this.getFormDataItemObj(this.formData.items, 'orgName').value = tempData.orgName;
            this.getFormDataItemObj(this.formData.items, 'itemCode').value = tempData.itemCode;
            this.getFormDataItemObj(this.formData.items, 'itemName').value = tempData.itemName;
        } else {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('页面数据已失效，请重新勾选送货单数据再进行操作')
            });
        }
        this.isLocal = location.hostname === 'localhost.midea.com';
        this.tableData = [];
        this.beforeItemCode = tempData.itemCode;
        if (this.isLocal) {
            this.getBuList();
        }
        this.onSubmit();
        /* 新品提醒字典 */
        this.getDictByCode('NEW_DELIVERY_REMINDER_ORG');
    },
    created () {
        document.addEventListener('keydown', this.handKeyCode);
    },
    beforeDestroy () {
        document.removeEventListener('keydown', this.handKeyCode);
    }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
}
</style>